import axios from "axios";

// Use environment variable for API base URL (following admin project pattern)
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL + "/";

// Create instance with baseURL and default headers
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  withCredentials: false,
});

// Attach token dynamically before each request using interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
